import type { ComputedRef } from 'vue'
import type { StrictLocaleObject } from '../../shared/locales'

export function useLocaleObject(): ComputedRef<StrictLocaleObject> {
  const { locale, locales } = useI18n()
  return computed(() => locales.value.find(l => l.code === locale.value))
}
